export const AUTOMATION_ACTIONS = {
    PUBLISH: 'publish',
    UNPUBLISH: 'unpublish',
    DELETE: 'delete',
} as const;

export type AutomationAction = (typeof AUTOMATION_ACTIONS)[keyof typeof AUTOMATION_ACTIONS];
